const NoFovouriteFilePopup = ({ titleText, setNoFovouritePopup }) => {
    return (
        <div className="backwrap">
            <div className="freeliModal">
                <div className="freeliModalHead">
                    <h4 className="popupTitle text-text-headings dark:text-text-light">{"No favourited file(s) yet."}</h4>
                    <span onClick={() => setNoFovouritePopup(false)} className="closeModal text-text-body" data-for="rightSection_tooltip" data-tip="Close" currentitem="false"></span>
                </div>
                <div className="freeliModalBody">
                    <div className="delDesc dark:!bg-transparent">{"There are no favourited file(s). When you starred a file, it will appear here."}</div>
                </div>
                <div className="freeliModalFoot">
                    <button onClick={() => setNoFovouritePopup(false)} className="btnCancel">Close</button>
                </div>
            </div>
        </div>
    );
};

export default NoFovouriteFilePopup;